// extracted by mini-css-extract-plugin
export default {"wrapper":"o4-z","play":"p4-z"};